import {
  LOGGED_IN,
  LOGGED_OUT,
  LOGIN_FAILED,
  USER_PROFILE_UPDATE_RECEIVED,
  SET_CURRENCY,
  SET_PROFILE_ERROR,
  SET_DEPOSIT_MODE,
  FINISH_REGISTRATION,
  SET_FREE_BONUSES,
  SET_VERIFICATION_RESPONSE,
} from '../actions/actionTypes';
import { DepositModeEnum } from '../constants/enums/depositMode';

const initialState = {
  depositMode: DepositModeEnum.Cash,
  freeBonuses: [],
  captcha: {
    data: {},
  },
};

const UserReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DEPOSIT_MODE:
      return {
        ...state,
        depositMode: action.depositMode,
      };
    case SET_FREE_BONUSES:
      return {
        ...state,
        freeBonuses: action.payload,
      };
    case SET_VERIFICATION_RESPONSE:
      return {
        ...state,
        verification: action.payload,
      };
    case LOGGED_IN:
      return Object.assign({}, state, {
        authData: action.payload.authData, // authData holds user Id and token which are needed  for logging in later without entering password.
        rfid: action.payload.rfid,
        loginInProgress: false,
        loginFailReason: undefined,
        loggedIn: true,
        loggedInByRFID: action.payload.loggedInByRFID,
      });
    case LOGIN_FAILED:
      return Object.assign({}, state, {
        loginFailReason: action.payload,
        loginInProgress: false,
        loggedIn: false,
      });
    case LOGGED_OUT:
      return Object.assign({}, state, {
        authData: undefined,
        profile: undefined,
        freeBonuses: [],
        loginInProgress: undefined,
        loggedIn: false,
        loggedInByRFID: false,
      });
    case USER_PROFILE_UPDATE_RECEIVED:
      return Object.assign({}, state, { profile: { ...state.profile, ...action.payload } });
    case FINISH_REGISTRATION:
      return {
        ...state,
        registerSucceed: action.payload,
      };
    case SET_PROFILE_ERROR:
      return {
        ...state,
        profileError: action.payload,
      };
    case SET_CURRENCY:
      return {
        ...state,
        currency: action.payload,
      };
    default:
      return state;
  }
};

export default UserReducer;
